module.exports = __webpack_public_path__ + "img/SouthAfricans.3270bb61.svg";